export const radius = {
  containers: {
    primary: 8,
    secondary: 24,
  },
  controls: 90,
};
